import { Box, Text, VStack } from '@chakra-ui/react'
import { useRouteError } from 'react-router-dom'

import swoosh from '../../assets/swoosh.png'

export type AppErrorProps = {
  error?: Error
}

/**
 * Full screen application error
 */
export const AppError = ({ error }: AppErrorProps) => {
  const routeError = useRouteError() as Error
  return (
    <VStack h="calc(100vh)" justify="center" align="center">
      <VStack flex="2" justify="center" align="center">
        <Box as="img" height={82} width={82} src={swoosh} alt="Logo" />
        <Text fontSize="2xl" color="red.80">
          Application Error:
        </Text>
        <Text fontSize="xl" color="red.80">
          {error?.message || routeError.message || 'Unknown error'}
        </Text>
      </VStack>
      <Box flex="1" />
    </VStack>
  )
}
